module.exports = __webpack_public_path__ + "img/VL_19_02.59718042.png";